<!--
  This represents a tic tac toe game.

  Props:
  current_player is 0/1.
  is_active is true if the board should be interactive.

  Dispatches a 'moved' event when a player makes a move.
-->
<script>
  import { createEventDispatcher } from 'svelte';

  import { STATE, calc_state} from './state.js';

  // props with default values
  export let current_player = 0;
  export let is_active = true;

  const dispatch = createEventDispatcher();

  // Contains the state of each cell in the board.
  let cell_state = [
    STATE.PLAYING, STATE.PLAYING, STATE.PLAYING,
    STATE.PLAYING, STATE.PLAYING, STATE.PLAYING,
    STATE.PLAYING, STATE.PLAYING, STATE.PLAYING,
  ];

  // The state of this board
  let board_state = STATE.PLAYING;

  function make_move(cell_id) {
    if (!is_active) {
      // Board is not active, return
      return;
    }
    if (cell_state[cell_id] != 0) {
      // Cell is occupied, return
      return;
    }

    // Stores current_player+1 since STATE represents players with [1, 2].
    cell_state[cell_id] = current_player + 1;
    board_state = calc_state(cell_state);

    // Send event to parent
    dispatch('moved', {
      cell_id: cell_id,
      board_state: board_state,
    });
  }
</script>


<div
  class="board"

  class:board_state-1="{ board_state == 1 }"
  class:board_state-2="{ board_state == 2 }"
  class:board_state-3="{ board_state == 3 }"

  class:active_player-0="{ board_state == 0 && is_active && current_player == 0 }"
  class:active_player-1="{ board_state == 0 && is_active && current_player == 1 }"
  >
  {#if board_state == 0}
    {#each cell_state as state, i}
        <a
          class="cell"

          class:cell_state-0="{ cell_state[i] == 0 }"
          class:cell_state-1="{ cell_state[i] == 1 }"
          class:cell_state-2="{ cell_state[i] == 2 }"

          on:click="{ () => make_move(i) }"
        ></a>
    {/each}
  {/if}
</div>


<style>
/* === The styling for board === */
.board {
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;

  border: 1px solid #ddd;
}

.board.active_player-0 {
  border: 3px solid var(--p0);
}
.board.active_player-1 {
  border: 3px solid var(--p1);
}

.board_state-1 {
  background-color: var(--p0);
}
.board_state-2 {
  background-color: var(--p1);
}
.board_state-3 {
  background-color: var(--gray)
}


/* === The styling for the cells === */
.active_player-0 > .cell.cell_state-0:hover {
  background-color: var(--p0);
}
.active_player-1 > .cell.cell_state-0:hover {
  background-color: var(--p1);
}

.cell {
  border: 1px solid #ddd;
}

.cell_state-1 {
  background-color: var(--p0);
}
.cell_state-2 {
  background-color: var(--p1);
}
</style>
